import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { LIST_VARIAVEIS_INIT, CREATE_VARIAVEL_INIT, UPDATE_VARIAVEL_INIT, DELETE_VARIAVEL_INIT } from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { listVariaveisSuccess, createVariavelSuccess, updateVariavelSuccess, deleteVariavelSuccess, errorVariaveisMsg } from './actions';
import { listarVariaveis, criarVariavel, atualizarVariavel, removerVariavel } from 'src/integracoes/servicos/mongo-atlas/funcoes/variaveis';

// --------------------------- List Variáveis ---------------------------------------------------------
const fetchListarVariaveis = async () => {
  try {
    const { status, dados, mensagem } = await listarVariaveis();
    if (status && Array.isArray(dados)) {
      return { isError: false, variaveis: dados, errorMessage: null };
    }
    return { isError: true, variaveis: [], errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarVariaveis() {
  try {
    const { isError, variaveis, errorMessage } = yield call(fetchListarVariaveis);
    if (!isError) {
      yield put(listVariaveisSuccess({ variaveis }));
    } else {
      yield put(errorVariaveisMsg({ msg: errorMessage || 'Erro ao carregar variáveis' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorVariaveisMsg({ msg: mensagem }));
  }
}

function* watchListarVariaveisInit() {
  yield takeEvery(LIST_VARIAVEIS_INIT as any, parseListarVariaveis);
}

// --------------------------- Criar Variável ---------------------------------------------------------
const fetchCriarVariavel = async (nome: string, placeholder: string) => {
  try {
    const { status, dados, mensagem } = await criarVariavel({ nome, placeholder });
    if (status && dados) {
      return { isError: false, variavel: dados, errorMessage: null };
    }
    return { isError: true, variavel: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarVariavel({ payload }: any) {
  try {
    const { nome, placeholder } = payload;
    const { isError, variavel, errorMessage } = yield call(fetchCriarVariavel, nome, placeholder);
    if (!isError) {
      yield put(createVariavelSuccess({ variavel }));
    } else {
      yield put(errorVariaveisMsg({ msg: errorMessage || 'Erro ao criar variável' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorVariaveisMsg({ msg: mensagem }));
  }
}

function* watchCriarVariavelInit() {
  yield takeEvery(CREATE_VARIAVEL_INIT as any, parseCriarVariavel);
}

// --------------------------- Atualizar Variável ---------------------------------------------------------
const fetchAtualizarVariavel = async (id: string, nome: string, placeholder: string) => {
  try {
    const { status, dados, mensagem } = await atualizarVariavel(id, { nome, placeholder });
    if (status && dados) {
      return { isError: false, variavel: dados, errorMessage: null };
    }
    return { isError: true, variavel: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarVariavel({ payload }: any) {
  try {
    const { id, nome, placeholder } = payload;
    const { isError, variavel, errorMessage } = yield call(fetchAtualizarVariavel, id, nome, placeholder);
    if (!isError) {
      yield put(updateVariavelSuccess({ variavel }));
    } else {
      yield put(errorVariaveisMsg({ msg: errorMessage || 'Erro ao atualizar variável' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorVariaveisMsg({ msg: mensagem }));
  }
}

function* watchAtualizarVariavelInit() {
  yield takeEvery(UPDATE_VARIAVEL_INIT as any, parseAtualizarVariavel);
}

// --------------------------- Remover Variável ---------------------------------------------------------
const fetchRemoverVariavel = async (id: string) => {
  try {
    const { status, mensagem } = await removerVariavel(id);
    if (status) {
      return { isError: false, errorMessage: null };
    }
    return { isError: true, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseRemoverVariavel({ payload }: any) {
  try {
    const { id } = payload;
    const { isError, errorMessage } = yield call(fetchRemoverVariavel, id);
    if (!isError) {
      yield put(deleteVariavelSuccess({ id }));
    } else {
      yield put(errorVariaveisMsg({ msg: errorMessage || 'Erro ao remover variável' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorVariaveisMsg({ msg: mensagem }));
  }
}

function* watchRemoverVariavelInit() {
  yield takeEvery(DELETE_VARIAVEL_INIT as any, parseRemoverVariavel);
}

export default function* variaveisSaga() {
  yield all([
    fork(watchListarVariaveisInit),
    fork(watchCriarVariavelInit),
    fork(watchAtualizarVariavelInit),
    fork(watchRemoverVariavelInit)
  ]);
}
